import * as React from 'react';
import { Svg } from '../svg';

function SvgPostIcon({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="url(#post-icon_svg__pattern0)" d="M0 0h48v48H0z" />
      <defs>
        <pattern
          id="post-icon_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#post-icon_svg__image0_2701_47079"
            transform="scale(.0125)"
          />
        </pattern>
        <image
          id="post-icon_svg__image0_2701_47079"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgPostIcon);
export default ForwardRef;
